import { useQuery } from "@tanstack/react-query";
import { type IHistoryArgs, getHistory } from "@/api";
import { withAuth } from "@/state/withAuth";

function authGetHistory(params: IHistoryArgs) {
    return withAuth(() => getHistory(params));
}

export function useHistory(params: IHistoryArgs) {
    return useQuery({
        queryKey: ["history", params.id, params.language, params.contentType],
        queryFn: () => authGetHistory(params),
        enabled: !!params.id && !!params.language && !!params.contentType,
        staleTime: 1000 * 60 * 10,
    });
}
